import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding: 1.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-bottom: 1px solid #ccc;
`;
